module.exports = __webpack_public_path__ + "images/112_640.jpg";